import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components


import workStyle from "assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx";


import SectionService from "./SectionService.jsx";



class WorkSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
       
      <SectionService />
      </div>
    );
  }
}

export default withStyles(workStyle)(WorkSection);



// WEBPACK FOOTER //
// ./src/views/OilPage/Sections/WorkSection.jsx